import React from "react";
import PropTypes from "prop-types";
import { upperFirst } from "lodash";

import { FacilityPageSection } from "components/facility/FacilityPageSection";
import { labelHour } from "utils/time";
import { Heading } from "components/storages/Common";

import "./HoursSection.scss";

const daysOfTheWeek = [
	"sunday",
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday"
];

const HoursList = ({ title, hours }) => (
	<div className="hours-list">
		<Heading
			className="hours-title"
			size="small"
			content={title}
			level="3"
		/>
		<table>
			<tbody>
				{daysOfTheWeek.map((day) => (
					<tr key={`${title}-${day}`}>
						<th>{`${upperFirst(day.slice(0, 3))}:`}</th>
						<td>{labelHour(hours[day])}</td>
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

HoursList.propTypes = {
	title: PropTypes.string,
	hours: PropTypes.shape({
		appointmentOnly: PropTypes.bool,
		open: PropTypes.string,
		closed: PropTypes.string
	})
};

const HoursSection = ({ access, office }) => (
	<FacilityPageSection
		className="hours-section"
		title="Hours"
		isCollapsable
	>
		<HoursList
			title="Office Hours"
			hours={office}
		/>
		<HoursList
			title="Access Hours"
			hours={access}
		/>
	</FacilityPageSection>
);

HoursSection.propTypes = {
	access: PropTypes.PropTypes.shape({
		open: PropTypes.string,
		closed: PropTypes.string
	}),
	office: PropTypes.PropTypes.shape({
		appointmentOnly: PropTypes.bool,
		open: PropTypes.string,
		closed: PropTypes.string
	})
};

export default HoursSection;
